import React, { forwardRef } from "react";
import { Stack, useTheme } from "@mui/material";
import { useResponsive } from "@app/hooks";
import { ContactUsForm } from "./contact-us-form";
import { FooterBrand } from "./footer-brands";
import { FooterLinks } from "./footer-links";
import { FooterPolicies } from "./footer-policies";
import { FooterBottom } from "./footer-bottom";

const Footer = forwardRef<HTMLDivElement>((props, ref) => {
  const theme = useTheme();
  const isMobile = useResponsive("down", "md");

  const footerSectionStyle = {
    width: "100%",
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    px: 4,
    py: 2,
    rowGap: 4,
    alignSelf: "center",
  };

  return (
    <Stack ref={ref} alignItems="center">
      <ContactUsForm
      // loading={loading}
      />
      <Stack
        sx={[
          footerSectionStyle,
          { flexDirection: "row", justifyContent: "center" },
        ]}
      >
        <Stack
          sx={{
            width: "100%",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            gap: isMobile ? 2 : 18,
            px: isMobile ? 0 : 18,
            py: 2,
          }}
        >
          <FooterBrand />
          <FooterLinks />
          <FooterPolicies />
        </Stack>
      </Stack>
      <Stack sx={footerSectionStyle}>
        <FooterBottom />
      </Stack>
    </Stack>
  );
});

export { Footer };
